import React from 'react'

export default function notfound() {
    return (
        <div>
            
        </div>
    )
}
